<div class="lang-switcher">
  <span href="#" class="quickLinks__link">
    <span class="languageSwitcher">
      <span class="languageSwitcher__currentLanguage group px-2">
        <span class="languageSwitcher__lang">
          {{ language() }}
          <img src="./assets/img/arrow-bottom.svg" class="arrow-down" alt="arrow-bottom" />
        </span>
        <div class="absolute top-6 pt-4 hidden group-hover:flex flex-col w-full bg-white px-2 rounded-lg">
          @if (language() !== languages.nl) {
            <span
              class="languageSwitcher__lang"
              (click)="changeLanguage(languages.nl)"
              (keydown)="changeLanguage(languages.nl)"
              role="button"
              tabindex="0"
            >
              {{ 'common.lang.nl' | translate }}
            </span>
          }
          @if (language() !== languages.fr) {
            <span
              class="languageSwitcher__lang"
              (click)="changeLanguage(languages.fr)"
              (keydown)="changeLanguage(languages.fr)"
              role="button"
              tabindex="0"
            >
              {{ 'common.lang.fr' | translate }}
            </span>
          }
          @if (language() !== languages.en && englishAllowed) {
            <span
              class="languageSwitcher__lang"
              (click)="changeLanguage(languages.en)"
              (keydown)="changeLanguage(languages.en)"
              role="button"
              tabindex="0"
            >
              {{ 'common.lang.en' | translate }}
            </span>
          }
        </div>
      </span>
    </span>
  </span>
</div>
